
class GiftCardRadios extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.getSectionsToUpdate = this.getSectionsToUpdate.bind(this);
        this.updateGiftCardBuybox = this.updateGiftCardBuybox.bind(this);
    }

    connectedCallback() {
        this.GiftCardRadios = this;
        this.productInfoContainer = document.querySelector('.product__info-container');
        this.sectionId = this.dataset.section;
        this.ShopifyLocale = Shopify.locale == 'fr' ? '' : `/${Shopify.locale}`;
        this.VariantSelects = this.productInfoContainer.querySelector('variant-radios');

        this.bindEvents();
    }

    bindEvents() {
        this.GiftCardRadios.addEventListener('change', this.updateGiftCardBuybox);
    }

    getSectionsToUpdate() {
        return [
            `ProductInfo-${this.sectionId}`
        ]
    }

    updateGiftCardBuybox(event) {
        const productHandle = event.target.dataset.productHandle;
        const productVariantId = event.target.dataset.variantId;

        if (productHandle)

        this.productInfoContainer.classList.add('product__info-container--loading');

        let url = `${this.ShopifyLocale}/products/${productHandle}?section_id=${this.sectionId}`;
        if (productVariantId) {
            url += `&variant=${productVariantId}`;
        }

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.productInfoContainer.classList.remove('product__info-container--loading');
                    throw error;
                }
                return response.text();
            })
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const sectionsToUpdate = this.getSectionsToUpdate();

                for (let i = 0; i < sectionsToUpdate.length; i++) {
                    const oldSections = document.querySelectorAll(`#${sectionsToUpdate[i]}`)
                    for (let j = 0; j < oldSections.length; j++) {
                        const new_section = html.getElementById(sectionsToUpdate[i]);
                        if (oldSections[j] && new_section && !oldSections[j].isEqualNode(new_section)) oldSections[j].innerHTML = new_section.innerHTML;
                    }
                }
            })
            .finally(() => {
                this.productInfoContainer.classList.remove('product__info-container--loading');
            })
            .catch((error) => {
                this.productInfoContainer.classList.remove('product__info-container--loading');
                throw error;
            });
    }
}

customElements.define('w3-gift-card-radios', GiftCardRadios);
